<template>
  <div style="overflow-x: hidden;">
    <el-image class="round" :src="img" >
      <div slot="placeholder" class="image-slot">
        加载中<span class="dot">...</span>
      </div>
    </el-image>
    <h1 style="padding-left: 10px;">{{ msg }}</h1>
    <p style="padding-left: 10px;">{{abstract}}</p>
    <div v-html="detail.content"></div>
    <img class="head" v-if="!detail.content" src="../assets/illustration/产品详情-雪票详情/雪票.png" />
  </div>
</template>

<script>
import Qs from "qs";
import request from "../utils/request.js";
export default {
  name: "snowticketdetails",
  data() {
    return {
      msg: "云顶乐园-1天滑雪票（含雪具）",
      lang: 1,
      ID: 1,
      msg: "",
      abstract: "",
      img: "",
      detail: {},
    };
  },
  created() {
    this.ID = this.$route.query.ticket_id;
    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang;
    }
    console.log("ID:" + this.ID + " lang:" + this.lang);

    this.$axios({
      url: "/myyd/public/ticket_detail",
      method: "post",
      header: { "content-type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        ticket_id: this.ID,
        lang: this.lang,
      }),
    }).then((res) => {
      console.log("请求结果：", res.data.data);
      let params = res.data.data;
      this.detail = res.data.data;
      this.msg = params.title;
      this.abstract = params.abstract;
      this.img = params.img;
    });
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.round {
  width: 100%;
  height: 100vw;
  border-radius: 0 0 0 50px;
}
.head {
  width: 100%;
}
#huanpiaoshiyong {
  border: 1px solid #7e7e7e;
  opacity: 1;
  border-radius: 10px;
  padding-bottom: 1px;
  width: 60px;
  height: 14px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 14px;
  color: #646464;
  text-align: center;
}
#buketui {
  width: 60px;
  height: 14px;
  border: 1px solid #fe0000;
  opacity: 1;
  border-radius: 10px;
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 14px;
  color: #fe0000;
  vertical-align: middle;
  text-align: center;
}

h1 {
  
  text-align: justify;
  padding-left: 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 30px;
  color: #000000;
  opacity: 1;
}
h2 {
  width: 100%;
  height: 23px;
  text-align: justify;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 15px;
  color: #1f1f1f;
  opacity: 1;
}
.table1 {
  text-align: left;
  vertical-align: top;

  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  opacity: 1;
}

table tr td:first-child {
  width: 70px;
  height: 17px;
  vertical-align: top;

  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  opacity: 1;
}
table tr td:first-child + td {
  padding-right: 10px;
  padding-bottom: 15px;
  text-align: justify;
}

hr {
  height: 0px;
  border: 1px solid #dddddd;
  opacity: 1;
}
p {
  width: 100%;
  text-align: justify;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  opacity: 0.5;
}
.td1 {
  padding-right: 10px;
  text-align: justify;
}
.td2 {
  text-align: justify;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SnowTicketDetails.vue